import { useEffect, useRef } from "react";
import { Box, } from '@material-ui/core'
import { Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import { debounce } from 'lodash';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);
ChartJS.defaults.font.family = "Questrial";

const infoSVG = `<svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="3" width="3" height="9" fill="white"/><path d="M7.5 0C3.35476 0 0 3.35438 0 7.5C0 11.6452 3.35438 15 7.5 15C11.6452 15 15 11.6456 15 7.5C15 3.35481 11.6456 0 7.5 0ZM8.27019 10.4772C8.27019 10.7141 7.92466 10.951 7.50015 10.951C7.05589 10.951 6.74001 10.7141 6.74001 10.4772V6.71584C6.74001 6.43942 7.05592 6.25181 7.50015 6.25181C7.92466 6.25181 8.27019 6.43942 8.27019 6.71584V10.4772ZM7.50018 5.34363C7.04605 5.34363 6.69067 5.00798 6.69067 4.6328C6.69067 4.25766 7.04607 3.93187 7.50018 3.93187C7.94443 3.93187 8.29986 4.25766 8.29986 4.6328C8.29986 5.00798 7.9444 5.34363 7.50018 5.34363Z" fill="#585C5E"/></svg>`;
const infoImg = new Image();
infoImg.src = URL.createObjectURL(new Blob([infoSVG], { type: "image/svg+xml" }));

const imagesLabelsIcons = [
  {family : 'communication', src:`data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNy45MTY2NyIgY3k9IjcuOTE2NjciIHI9IjUuNDE2NjciIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS4xNTgzMiAxLjE5MTM1QzUuODI3NTIgMC40NjIyNTQgNi44MTUwNyAwIDcuOTE2NjcgMEM5LjAxODE4IDAgMTAuMDA1NyAwLjQ2MjIwOCAxMC42NzQ5IDEuMTkxMjRDMTEuNjkyNCAxLjEyMzg5IDEyLjczNTggMS40NTg1OCAxMy41MTQ4IDIuMTk2NTlDMTQuMjkzOCAyLjkzNDYgMTQuNjQ3MSAzLjkyMzE1IDE0LjU3NjEgNC44ODcwN0MxNS4zNDU1IDUuNTIxMDQgMTUuODMzMyA2LjQ1NjU0IDE1LjgzMzMgNy41QzE1LjgzMzMgOC41NDM2OSAxNS4zNDUzIDkuNDc5MzEgMTQuNTc1NyAxMC4xMTMzQzE0LjY0NjYgMTEuMDc3MSAxNC4yOTMzIDEyLjA2NTQgMTMuNTE0NCAxMi44MDMzQzEyLjczNTUgMTMuNTQxMiAxMS42OTIzIDEzLjg3NTggMTAuNjc1IDEzLjgwODdDMTAuMDA1OCAxNC41Mzc4IDkuMDE4MjYgMTUgNy45MTY2NyAxNUM2LjgxNTE1IDE1IDUuODI3NjQgMTQuNTM3OCA1LjE1ODQ1IDEzLjgwODhDNC4xNDA5NiAxMy44NzYyIDMuMDk3NDkgMTMuNTQxNSAyLjMxODQ2IDEyLjgwMzVDMS41Mzk0NSAxMi4wNjU0IDEuMTg2MTcgMTEuMDc2OCAxLjI1NzI2IDEwLjExMjlDMC40ODc4MjEgOS40Nzg5MiAwIDguNTQzNDYgMCA3LjVDMCA2LjQ1NjQ2IDAuNDg3ODcgNS41MjA5NSAxLjI1NzM3IDQuODg2OTdDMS4xODYzNiAzLjkyMzEyIDEuNTM5NjYgMi45MzQ2NyAyLjMxODYgMi4xOTY3MkMzLjA5NzU1IDEuNDU4NzcgNC4xNDA5MiAxLjEyNDA3IDUuMTU4MzIgMS4xOTEzNVpNMTAuODQ4MSA2LjEwNDU0QzExLjA0MzYgNS44NDUyOCAxMC45ODAyIDUuNDg0OTcgMTAuNzA2NSA1LjI5OTc3QzEwLjQzMjkgNS4xMTQ1NyAxMC4wNTI1IDUuMTc0NjIgOS44NTcwMiA1LjQzMzlMNy4yMjk5OSA4LjkxODE1TDUuOTExMzggNy42NjlDNS42NzM1NiA3LjQ0MzY5IDUuMjg3OTggNy40NDM2OSA1LjA1MDE2IDcuNjY5QzQuODEyMzQgNy44OTQzMSA0LjgxMjM0IDguMjU5NTQgNS4wNTAxNiA4LjQ4NDg1TDYuODc3MTEgMTAuMjE1NkM3LjAwMzY5IDEwLjMzNTUgNy4xNzk0OCAxMC4zOTY2IDcuMzU3OTUgMTAuMzgyNkM3LjUzNjM0IDEwLjM2ODcgNy42OTkyMiAxMC4yODEgNy44MDMyNCAxMC4xNDNMMTAuODQ4MSA2LjEwNDU0WiIgZmlsbD0iI0ZGNTEwNiIvPgo8L3N2Zz4K`},
  {family : 'efficacite', src : `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNy45MTY2NyIgY3k9IjcuOTE2NjciIHI9IjUuNDE2NjciIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS4xNTgzMiAxLjE5MTM1QzUuODI3NTIgMC40NjIyNTQgNi44MTUwNyAwIDcuOTE2NjcgMEM5LjAxODE4IDAgMTAuMDA1NyAwLjQ2MjIwOCAxMC42NzQ5IDEuMTkxMjRDMTEuNjkyNCAxLjEyMzg5IDEyLjczNTggMS40NTg1OCAxMy41MTQ4IDIuMTk2NTlDMTQuMjkzOCAyLjkzNDYgMTQuNjQ3MSAzLjkyMzE1IDE0LjU3NjEgNC44ODcwN0MxNS4zNDU1IDUuNTIxMDQgMTUuODMzMyA2LjQ1NjU0IDE1LjgzMzMgNy41QzE1LjgzMzMgOC41NDM2OSAxNS4zNDUzIDkuNDc5MzEgMTQuNTc1NyAxMC4xMTMzQzE0LjY0NjYgMTEuMDc3MSAxNC4yOTMzIDEyLjA2NTQgMTMuNTE0NCAxMi44MDMzQzEyLjczNTUgMTMuNTQxMiAxMS42OTIzIDEzLjg3NTggMTAuNjc1IDEzLjgwODdDMTAuMDA1OCAxNC41Mzc4IDkuMDE4MjYgMTUgNy45MTY2NyAxNUM2LjgxNTE1IDE1IDUuODI3NjQgMTQuNTM3OCA1LjE1ODQ1IDEzLjgwODhDNC4xNDA5NiAxMy44NzYyIDMuMDk3NDkgMTMuNTQxNSAyLjMxODQ2IDEyLjgwMzVDMS41Mzk0NSAxMi4wNjU0IDEuMTg2MTcgMTEuMDc2OCAxLjI1NzI2IDEwLjExMjlDMC40ODc4MjEgOS40Nzg5MiAwIDguNTQzNDYgMCA3LjVDMCA2LjQ1NjQ2IDAuNDg3ODcgNS41MjA5NSAxLjI1NzM3IDQuODg2OTdDMS4xODYzNiAzLjkyMzEyIDEuNTM5NjYgMi45MzQ2NyAyLjMxODYgMi4xOTY3MkMzLjA5NzU1IDEuNDU4NzcgNC4xNDA5MiAxLjEyNDA3IDUuMTU4MzIgMS4xOTEzNVpNMTAuODQ4MSA2LjEwNDU0QzExLjA0MzYgNS44NDUyOCAxMC45ODAyIDUuNDg0OTcgMTAuNzA2NSA1LjI5OTc3QzEwLjQzMjkgNS4xMTQ1NyAxMC4wNTI1IDUuMTc0NjIgOS44NTcwMiA1LjQzMzlMNy4yMjk5OSA4LjkxODE1TDUuOTExMzggNy42NjlDNS42NzM1NiA3LjQ0MzY5IDUuMjg3OTggNy40NDM2OSA1LjA1MDE2IDcuNjY5QzQuODEyMzQgNy44OTQzMSA0LjgxMjM0IDguMjU5NTQgNS4wNTAxNiA4LjQ4NDg1TDYuODc3MTEgMTAuMjE1NkM3LjAwMzY5IDEwLjMzNTUgNy4xNzk0OCAxMC4zOTY2IDcuMzU3OTUgMTAuMzgyNkM3LjUzNjM0IDEwLjM2ODcgNy42OTkyMiAxMC4yODEgNy44MDMyNCAxMC4xNDNMMTAuODQ4MSA2LjEwNDU0WiIgZmlsbD0iIzRGMzlGRiIvPgo8L3N2Zz4K`},
  {family : 'leadership', src : `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNy45MTY2NyIgY3k9IjcuOTE2NjciIHI9IjUuNDE2NjciIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS4xNTgzMiAxLjE5MTM1QzUuODI3NTIgMC40NjIyNTQgNi44MTUwNyAwIDcuOTE2NjcgMEM5LjAxODE4IDAgMTAuMDA1NyAwLjQ2MjIwOCAxMC42NzQ5IDEuMTkxMjRDMTEuNjkyNCAxLjEyMzg5IDEyLjczNTggMS40NTg1OCAxMy41MTQ4IDIuMTk2NTlDMTQuMjkzOCAyLjkzNDYgMTQuNjQ3MSAzLjkyMzE1IDE0LjU3NjEgNC44ODcwN0MxNS4zNDU1IDUuNTIxMDQgMTUuODMzMyA2LjQ1NjU0IDE1LjgzMzMgNy41QzE1LjgzMzMgOC41NDM2OSAxNS4zNDUzIDkuNDc5MzEgMTQuNTc1NyAxMC4xMTMzQzE0LjY0NjYgMTEuMDc3MSAxNC4yOTMzIDEyLjA2NTQgMTMuNTE0NCAxMi44MDMzQzEyLjczNTUgMTMuNTQxMiAxMS42OTIzIDEzLjg3NTggMTAuNjc1IDEzLjgwODdDMTAuMDA1OCAxNC41Mzc4IDkuMDE4MjYgMTUgNy45MTY2NyAxNUM2LjgxNTE1IDE1IDUuODI3NjQgMTQuNTM3OCA1LjE1ODQ1IDEzLjgwODhDNC4xNDA5NiAxMy44NzYyIDMuMDk3NDkgMTMuNTQxNSAyLjMxODQ2IDEyLjgwMzVDMS41Mzk0NSAxMi4wNjU0IDEuMTg2MTcgMTEuMDc2OCAxLjI1NzI2IDEwLjExMjlDMC40ODc4MjEgOS40Nzg5MiAwIDguNTQzNDYgMCA3LjVDMCA2LjQ1NjQ2IDAuNDg3ODcgNS41MjA5NSAxLjI1NzM3IDQuODg2OTdDMS4xODYzNiAzLjkyMzEyIDEuNTM5NjYgMi45MzQ2NyAyLjMxODYgMi4xOTY3MkMzLjA5NzU1IDEuNDU4NzcgNC4xNDA5MiAxLjEyNDA3IDUuMTU4MzIgMS4xOTEzNVpNMTAuODQ4MSA2LjEwNDU0QzExLjA0MzYgNS44NDUyOCAxMC45ODAyIDUuNDg0OTcgMTAuNzA2NSA1LjI5OTc3QzEwLjQzMjkgNS4xMTQ1NyAxMC4wNTI1IDUuMTc0NjIgOS44NTcwMiA1LjQzMzlMNy4yMjk5OSA4LjkxODE1TDUuOTExMzggNy42NjlDNS42NzM1NiA3LjQ0MzY5IDUuMjg3OTggNy40NDM2OSA1LjA1MDE2IDcuNjY5QzQuODEyMzQgNy44OTQzMSA0LjgxMjM0IDguMjU5NTQgNS4wNTAxNiA4LjQ4NDg1TDYuODc3MTEgMTAuMjE1NkM3LjAwMzY5IDEwLjMzNTUgNy4xNzk0OCAxMC4zOTY2IDcuMzU3OTUgMTAuMzgyNkM3LjUzNjM0IDEwLjM2ODcgNy42OTkyMiAxMC4yODEgNy44MDMyNCAxMC4xNDNMMTAuODQ4MSA2LjEwNDU0WiIgZmlsbD0iI0YzOTBGRiIvPgo8L3N2Zz4K`},
  {family : 'error', src : `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMTRDMTAuODY2IDE0IDE0IDEwLjg2NiAxNCA3QzE0IDMuMTM0MDEgMTAuODY2IDAgNyAwQzMuMTM0MDEgMCAwIDMuMTM0MDEgMCA3QzAgMTAuODY2IDMuMTM0MDEgMTQgNyAxNFoiIGZpbGw9IiM5Nzk3OTciLz4KPHBhdGggZD0iTTE0IDYuOTk5OTZDMTQgMTAuODUgMTAuODUgMTQgNi45OTk5OSAxNEM0Ljc2ODc2IDE0IDIuODAwMDEgMTIuOTkzNyAxLjUzMTI1IDExLjM3NUMyLjcxMjUgMTIuMzM3NSA0LjI0Mzc1IDEyLjkwNjIgNS45MDYyMyAxMi45MDYyQzkuNzU2MjMgMTIuOTA2MiAxMi45MDYyIDkuNzU2MjQgMTIuOTA2MiA1LjkwNjIzQzEyLjkwNjIgNC4yNDM3NSAxMi4zMzc1IDIuNzEyNSAxMS4zNzUgMS41MzEyNUMxMi45OTM3IDIuNzk5OTUgMTQgNC43Njg3IDE0IDYuOTk5OTZaIiBmaWxsPSIjOTc5Nzk3Ii8+CjxwYXRoIGQ9Ik0xMC4xOTM3IDEwLjE5MzdDOS45MzEyMiAxMC40NTYyIDkuNDkzNyAxMC40NTYyIDkuMjMxMjEgMTAuMTkzN0w2Ljk5OTk4IDcuOTYyNDhMNC43Njg3NCAxMC4xOTM3QzQuNTA2MjUgMTAuNDU2MiA0LjA2ODczIDEwLjQ1NjIgMy44MDYyNCAxMC4xOTM3QzMuNTQzNzUgOS45MzEyMiAzLjU0Mzc1IDkuNDkzNyAzLjgwNjI0IDkuMjMxMjFMNi4wMzc0OCA2Ljk5OTk4TDMuODA2MjQgNC43Njg3NEMzLjU0Mzc1IDQuNTA2MjUgMy41NDM3NSA0LjA2ODczIDMuODA2MjQgMy44MDYyNEM0LjA2ODczIDMuNTQzNzUgNC41MDYyNSAzLjU0Mzc1IDQuNzY4NzQgMy44MDYyNEw2Ljk5OTk4IDYuMDM3NDhMOS4yMzEyMSAzLjgwNjI0QzkuNDkzNyAzLjU0Mzc1IDkuOTMxMjIgMy41NDM3NSAxMC4xOTM3IDMuODA2MjRDMTAuNDU2MiA0LjA2ODczIDEwLjQ1NjIgNC41MDYyNSAxMC4xOTM3IDQuNzY4NzRMNy45NjI0OCA2Ljk5OTk4TDEwLjE5MzcgOS4yMzEyMUMxMC40NTYyIDkuNDkzNyAxMC40NTYyIDkuOTMxMTkgMTAuMTkzNyAxMC4xOTM3WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==`}
]

const NewCertifChart = ({datas, maxHeight}) => {
  const wrapperRef = useRef(null);
  const tooltipRef = useRef(null);
  const chartRef = useRef(null);

  // ── Helpers ──────────────────────────────────────────────────────────────────
  function getFontSize(chart) {
    const w = chart.canvas.parentElement?.offsetWidth ?? 600;
    //return Math.max(8, Math.min(16, Math.round(w * 0.018)));
    return Math.max(6, Math.min(16, Math.round(w * 0.018)));
  }
  function getIconSize(chart) {
    const w = chart.canvas.parentElement?.offsetWidth ?? 600;
    //return Math.max(10, Math.min(15, Math.round(w * 0.025)));
    return Math.max(8, Math.min(15, Math.round(w * 0.025)));
  }
  function getDotRadius(chart) {
    const w = chart.canvas.parentElement?.offsetWidth ?? 600;
    //return Math.max(2.5, Math.min(5, w * 0.007));
    return Math.max(2, Math.min(5, w * 0.007));
  }
  function getInfoPos(r, dataValues) {
    let dirX = 0, dirY = 0, count = 0;
    for (let i = 0; i < datas?.labels?.length; i++) {
      if (dataValues[i] <= 0) continue;
      const angle = r.getIndexAngle(i) - Math.PI / 2;
      dirX += Math.cos(angle);
      dirY += Math.sin(angle);
      count++;
    }
    if (count === 0) return { x: r.xCenter, y: r.yCenter };
    const len = Math.sqrt(dirX * dirX + dirY * dirY);
    const dist = r.getDistanceFromCenterForValue(r.max) * 0.20;
    return { x: r.xCenter + (dirX / len) * dist, y: r.yCenter + (dirY / len) * dist };
  }

  // ── Plugins ──────────────────────────────────────────────────────────────────
  function getInfoSize(chart) {
    const w = chart.canvas.parentElement?.offsetWidth ?? 600;
    return Math.max(12, Math.min(20, Math.round(w * 0.028)));
  }
  const infoPositions = [];

  const labelIconsPlugin = {
    id: "labelIcons",
    afterDraw(chart) {
      if (datas?.labelsIcons) {
        const { ctx, scales: { r } } = chart;
        const items = r._pointLabelItems;
        if (!items) return;
        const iconSize = getIconSize(chart);
        const fontSize = getFontSize(chart);
        const gap = 4;
        ctx.save();
        ctx.font = `${fontSize}px Questrial`;
        let nbr = datas?.labels?.length || 0
        for (let i = 0; i < nbr; i++) {
          let findImg = imagesLabelsIcons?.find((el) => el.family === datas?.labelsIcons[i])
          if (!findImg) continue
          const img = new Image();
          img.src = findImg?.src
          if (!img.complete || !img.naturalWidth) continue;
          const item = items[i];
          const textW = ctx.measureText(datas?.labels[i]).width;
          //const centerY = (item.top + item.bottom) / 2;
          const centerY = item.y + ((item?.bottom - item?.top)/2)
          const iconY = centerY - iconSize / 2;
          let iconX;
          if (item.textAlign === "left") iconX = item.x + textW + gap;
          else if (item.textAlign === "right") iconX = item.x - textW - iconSize - gap;
          else iconX = item.x + textW / 2 + gap;
          ctx.drawImage(img, iconX, iconY, iconSize, iconSize);
        }
        ctx.restore();
      }
    },
  };

  const infoIconPlugin = {
    id: "infoIcons",
    afterDraw(chart, args, options) {
      if (options?.withoutTooltips !== true) {
        const { ctx, scales: { r } } = chart;
        const INFO_SIZE = getInfoSize(chart);
        infoPositions.length = 0;
        ctx.save();
        options?.datasets?.filter((el) => el.title !== "SEUILS").forEach((ds, di) => {
          const pos = getInfoPos(r, ds.data);
          infoPositions.push({ x: pos.x, y: pos.y, di, size: INFO_SIZE });
          ctx.beginPath();
          ctx.arc(pos.x, pos.y, INFO_SIZE / 2, 0, 2 * Math.PI);
          ctx.fillStyle = "#585C5E"
          ctx.fill();
          if (infoImg.complete && infoImg.naturalWidth) {
            ctx.drawImage(infoImg, pos.x - INFO_SIZE / 2, pos.y - INFO_SIZE / 2, INFO_SIZE, INFO_SIZE);
          }
        });
        ctx.restore();
      }
    },
  };

  const outerDotsPlugin = {
    id: "outerDots",
    afterDraw(chart, args, options) {
      const { ctx, scales: { r } } = chart;
      const dotR = getDotRadius(chart);
      ctx.save();
      let nbr = options?.labels?.length || 0
      for (let i = 0; i < nbr; i++) {
        const angle = r.getIndexAngle(i) - Math.PI / 2;
        const rPx = r.getDistanceFromCenterForValue(r.max);
        const x = r.xCenter + Math.cos(angle) * rPx;
        const y = r.yCenter + Math.sin(angle) * rPx;
        ctx.beginPath();
        ctx.arc(x, y, dotR, 0, 2 * Math.PI);
        if (options?.labelsDotColors) {
          ctx.fillStyle = options?.labelsDotColors[i];
        } else {
          ctx.fillStyle = "#ffffff";
        }
        ctx.strokeStyle = "rgba(181, 191, 205, 1)";
        ctx.lineWidth = 1;
        ctx.fill();
        ctx.stroke();
      }
      ctx.restore();
    },
  };

  const responsivePlugin = {
    id: "responsiveFont",
    beforeInit(chart) {
      applyFontSize(chart);
    },
    resize(chart) {
      //applyFontSize(chart);
      chart.update("none");
    },
    beforeUpdate(chart) {
      applyFontSize(chart);
    }
  };
  function applyFontSize(chart) {
    chart.options.scales.r.pointLabels.font = { size: getFontSize(chart), family: "Questrial" };
  }

  const perLabelPadding = {
    id: 'perLabelPadding',

    afterLayout(chart, args, options) {
      const scale = chart.scales.r;
      if (!scale) return;

      const items = scale._pointLabelItems;
      if (!items) return;

      items.forEach((item, i) => {
        //console.log(item)
        const angle = scale.getIndexAngle(i);

        let extra = 0
        if (i === 0) {
          extra = -10
        }
        if (i === items?.length / 2) {
          extra = +10
        }

        item.y += extra
      });
    }
  };


  useEffect(() => {
    const canvas = wrapperRef.current?.querySelector("canvas");
    const tooltipEl = tooltipRef.current;
    if (!canvas || !tooltipEl) return;

    const onMouseMove = (e) => {
      const rect = canvas.getBoundingClientRect();
      const mx = e.clientX - rect.left;
      const my = e.clientY - rect.top;
      const hit = infoPositions.find(
        (p) => Math.sqrt((mx - p.x) ** 2 + (my - p.y) ** 2) <= p.size / 2 + 4
      );
      if (hit) {
        //canvas.style.cursor = "pointer";
        const ds = datas?.datasets[hit.di];
        tooltipEl.innerHTML = `<div style="font-weight:600;color:black;white-space:pre-line;">${ds.tooltipText}</div>`;
        let tx = hit.x + hit.size / 2 + 8;
        let ty = hit.y - (tooltipEl.offsetHeight - 78) / 2;
        if (tx + tooltipEl.offsetWidth > rect.width - 10) tx = hit.x - tooltipEl.offsetWidth - hit.size / 2 - 8;
        tooltipEl.style.left = tx + "px";
        tooltipEl.style.top = ty + "px";
        tooltipEl.style.opacity = "1";
        tooltipEl.style.borderRadius = "0"
      } else {
        //canvas.style.cursor = "default";
        tooltipEl.style.opacity = "0";
      }
    };
    const onMouseLeave = () => {
      //tooltipEl.style.opacity = "0";
      canvas.style.cursor = "default";
    };

    canvas.addEventListener("mousemove", onMouseMove);
    canvas.addEventListener("mouseleave", onMouseLeave);
    return () => {
      canvas.removeEventListener("mousemove", onMouseMove);
      canvas.removeEventListener("mouseleave", onMouseLeave);
    };
  }, []);


  useEffect(() => {
    if (wrapperRef.current && chartRef.current) {
      const observer = new ResizeObserver(debounce((entries) => {
        for (let entry of entries) {
          if (chartRef.current) {
            chartRef.current.resize();
            chartRef.current.update("none");
          }
        }
      }));
      observer.observe(wrapperRef?.current);
      return () => {
          observer.disconnect();
      };
    }
  }, [wrapperRef?.current, chartRef?.current]);

  return (
    <div style={{
      display: "flex",
      width: "100%",
      height: "100%",
      fontFamily: "Questrial",
      overflow:"hidden",
      //justifyContent:"center",
      alignItems:"center",
    }}>
      <div ref={wrapperRef} style={{ flex: 1, minWidth: 0, minHeight: 0, position: "relative", overflow:"hidden" }}>
        <Radar
          ref={chartRef}
          data={{ labels : datas?.labels, datasets : datas?.datasets }}
          options={{
            animation: {
              duration: 1000, // animation initiale
            },
            devicePixelRatio: 2.5,
            responsive: true,
            maintainAspectRatio:true,
            scales: {
              r: {
                min: 0, max: 100,
                ticks: { stepSize: 20, display: false, backdropColor: "transparent" },
                grid: { color: "rgba(181, 191, 205, 1)", lineWidth: 1 },
                angleLines: { color: "rgba(181, 191, 205, 1)", lineWidth: 1 },
                pointLabels: {
                  display: true,
                  color: "#000000",
                  font: { size: 11, family: "Questrial" },
                  padding: 8,
                },
              },
            },
            plugins: {
              legend: { display: false },
              tooltip: { enabled: false },
              outerDots : {
                labels : datas?.labels,
                labelsDotColors : datas?.labelsDotColors,
              },
              infoIcons : {
                datasets : datas?.datasets,
                withoutTooltips : datas?.withoutTooltips,
              }
            },
            layout: {
                padding: {
                    left: datas?.labelsIcons ? 20 : 5,
                    right : datas?.labelsIcons ? 20 : 5,
                    top: datas?.labelsIcons ? 15 : 10,
                    bottom : datas?.labelsIcons ? 10 : 10,

                }
            }
          }}
          plugins={[perLabelPadding, labelIconsPlugin, infoIconPlugin, outerDotsPlugin, responsivePlugin]}
          style={{
            maxHeight:maxHeight && maxHeight,
            width:"100%"
          }}
        />
        <Box
          ref={tooltipRef}
          sx={{
            position: "absolute", pointerEvents: "none", opacity: 0,
            background: "#fff", border: "1px solid rgba(0,0,0,0.12)",
            borderRadius: "8px",
            padding: ["4px 6px", "5px 8px", "6px 10px", "8px 12px"],
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
            fontSize: ["10px", "11px", "11px", "12px"],
            color: "black",
            whiteSpace: "nowrap",
            transition: "opacity 0.15s ease",
          }}
        />
      </div>
    </div>
  );
}

export default NewCertifChart
